/**
 * iView Admin Pro 开发配置
 * */
/* eslint-disable */

const env = process.env.NODE_ENV;

const Setting = {
  name: 'yscy',
  // 是否使用 Mock 的数据，默认 开发环境为 true，生产环境为 false
  isMock: true,
  // 部署应用包时的基本 URL
  publicPath: env === 'development' ? '/' : 'https://admin.yscy.yiyouqi.com/',
  // BaseUrl: 'http://localhost:58003',
  // BaseUrl1: 'http://localhost:58003/Gemini',
  BaseUrl2: 'http://localhost:5264',
  BaseUrl: 'https://api.yscy.yiyouqi.com',
  BaseUrl1: 'https://api.yscy.yiyouqi.com/Gemini',
  // BaseUrl2: 'https://api2.yscy.yiyouqi.com',

  // 生产环境构建文件的目录名
  outputDir: 'dist',
  // 放置生成的静态资源 (js、css、img、fonts) 的 (相对于 outputDir 的) 目录。
  assetsDir: '',
  // 开发环境每次保存时 lint 代码，会将 lint 错误输出为编译警告
  // true || false || error
  lintOnSave: true,
  // iView Loader 的选项
  // 详见 http://www.iviewui.com/docs/guide/iview-loader
  iviewLoaderOptions: {
    prefix: false,
  },
};

if (env === 'test') {
  Setting.publicPath = 'https://admin.yscy.yiyouqi.com';
  Setting.BaseUrl = 'https://api.yscy.yiyouqi.com';
  Setting.BaseUrl1 = 'https://api.yscy.yiyouqi.com/Gemini';
  Setting.BaseUrl2 = 'https://api2.yscy.yiyouqi.com';
} else if (env === 'production') {
  Setting.publicPath = 'https://admin.yscy.yiyouqi.com';
  Setting.BaseUrl = 'https://api.yscy.yiyouqi.com';
  Setting.BaseUrl1 = 'https://api.yscy.yiyouqi.com/Gemini';
  Setting.BaseUrl2 = 'https://api2.yscy.yiyouqi.com';
}

module.exports = Setting;
